import React, { Fragment, useContext } from 'react';
import { AuthContext } from '../context/auth';
import ExchangeRate from '../components/ExchangeRate';

const Home = () => {
  const context = useContext(AuthContext);

  return (
    <Fragment>
      {context.user ? (
        <h1>Hi, {context.user.firstName + ' ' + context.user.lastName}!</h1>
      ) : (
        ''
      )}
      <h2>Welcome to Kuick Pay!</h2>
      <h4>Your favorite banking app in New Zealand.</h4>
      <ExchangeRate />
    </Fragment>
  );
};

export default Home;
